<template>
    <v-app>{{ nuit }} 
                <v-col>
      <v-card-title class="justify-center">

            <span class="headline blue--text text--darken-2 text-center" >
                Observation Néo par  Nuit
            </span>

      </v-card-title>
            <v-combobox
                v-model="year"
                :items="c_Years"
                label="Year"
            ></v-combobox>

            <unidoo-heatmap
                v-model="date"
                :values="availability"
                :missingAllowed="missingAllowed"
                :completeValue="(maxDefinedToZero) ? 0 : undefined"
                :year="year"
                :showCount="showCount"
                :rangeColor="(showCustomColor) ? customRangeColor : undefined"
                :noDataText="(showCustomMessage) ? customMessage : undefined"
                :returnObject="returnObject"
            ></unidoo-heatmap>
           <UnidooAlert />
        </v-col>
    </v-app>
</template>

<script>


export default {
    data() {
        
        return {
            nuit : "",
            availability : [],
            year: "",
            c_Years :[],
            date: new Date(Date.UTC(2021, 3, 5)),
            showCustomColor: true,
            missingAllowed: true,
            maxDefinedToZero: false,
            year: '',
            showCount: true,
            showCustomMessage: true,
            returnObject: true,
            customMessage: '',
            customRangeColor: ['#101010', '#282828', '#3E6097', '#3E6097', '#3E6097', '#3E6097'],
            custamRangeCalor: ['#fond00', '#zero00', '#000024', '#000200', '#000300', '#000000'],
            autre : ['#000000', '#CB00A3', '#AC006B', '#00FF00', '#00E0OO', '#000000']
        };
    },
    watch: {
        date (val) {
            if(val instanceof Date){ //RRVVBB
                this.$unidooAlert.showSuccess("Date sélectionnée : ", val.toLocaleDateString('fr-FR', {timeZone: "UTC",}));
            } else {
                //console.log(val);
                //const the_date = new Date(val);
            
                
                this.nuit = val.date.toLocaleDateString('fr-CA');
                //this.$unidooAlert.showSuccess("Entrée sélectionnée : ", val);.slice(0, 10)
                //this.nuit = val;
                //this.$unidooAlert.showSuccess("Date sélectionnée : ", val.date.toLocaleDateString('fr-FR'));
            }
        }
    },
    computed: {
        nextYear() {
            return (new Date().getFullYear() + 1).toString()
        },
        dateValue() {
            if(this.date){
                if(this.date instanceof Date) {
                    return this.date
                } else if (this.date instanceof Object) {
                    return this.date.date
                }
            }
        }
    },

    methods: {
        get_NEO_nuits_obs(){
            const othis=this;

            othis.url = backend_url + "/Neo/obs_info";
            othis.data_obs = {};
            this.axios.get(othis.url,othis.data)
            .then((res) => {
                othis.data_obs = res.data;

                othis.c_Years       = res.data.annees;
                othis.year          = res.data.annee;
                othis.availability  = res.data.st0;
            })
            .catch((error) => {
                console.error(error);
                console.log("PB get -> get_NEO_nuits_obs");
            });


        }
       
    },
    mounted: function() {
        this.get_NEO_nuits_obs();
        /*g.Update_info_nuits = setInterval(() => {
            this.get_NEO_nuits_obs();
          },20000);*/


    },

};
</script>